import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './article-combo-item.component.scss';
import * as $ from 'jquery';
import axios from 'axios';
var ArticleComboItem = /** @class */ (function (_super) {
    tslib_1.__extends(ArticleComboItem, _super);
    function ArticleComboItem(element) {
        return _super.call(this, element) || this;
    }
    ArticleComboItem.prototype.init = function () {
        this.playButton = this.element.querySelector('.js-video-play');
        this.closeButton = this.element.querySelector('.js-video-close');
        this.playerContainer = this.element.querySelector('.video-carousel-item__container');
        this.playerContent = this.element.querySelector('.video-carousel-item__playercontent');
        this.playerTimeContainer = this.element.querySelector('.video-carousel-item__time-placeholder');
        if (this.element.querySelector('.ot-video-containingBlock')) {
            this.player = this.playerContainer.querySelector('.ot-video-containingBlock');
        }
        if (this.element.classList.contains('js-no-video')) {
            this.showVideoNoImage(this.playButton);
        }
        this.video = this.element.querySelector('video');
        this.isExternal = false;
    };
    ArticleComboItem.prototype.bindEvents = function () {
        var _this = this;
        if (this.playButton) {
            this.playButton.addEventListener('click', function (event) { return _this.showVideo(event); });
        }
        if (this.closeButton) {
            this.closeButton.addEventListener('click', function (event) { return _this.hideVideo(event); });
        }
        // this.renderTime();
    };
    ArticleComboItem.prototype.showVideo = function (event) {
        event.preventDefault;
        this.hideActiveVideo(event);
        this.playerContainer.classList.add('video-carousel-item__container--playing');
        if (event.currentTarget.hasAttribute('data-youtube-id')) {
            this.isExternal = true;
            var videoExternal = event.currentTarget;
            var getVideo = videoExternal.getAttribute('data-youtube-id');
            this.createIframePlayer(getVideo);
            this.analyticsService.dtmVideoTrackerAutoSpot();
        }
        else {
            if (this.player) {
                if (this.video) {
                    this.player.style.height = "100%";
                    this.video.player.play();
                }
            }
        }
    };
    ArticleComboItem.prototype.hideVideo = function (event) {
        event.preventDefault;
        var removeIframe = this.playerContent.querySelector('iframe');
        this.playerContainer.classList.remove('video-carousel-item__container--playing');
        if (removeIframe) {
            this.playerContent.removeChild(removeIframe);
        }
        else {
            this.video.player.pause();
        }
    };
    ArticleComboItem.prototype.hideActiveVideo = function (event) {
        var selectedVideo = event.target;
        if (!selectedVideo.classList.contains('video-carousel-item__container--playing')) {
            var videoContainers = Array.from(document.querySelectorAll('.video-carousel-item__container--playing'));
            videoContainers.map(function (itemContainer) {
                itemContainer.classList.remove('video-carousel-item__container--playing');
                var iframeExistence = itemContainer.querySelector('iframe');
                if (iframeExistence) {
                    var iframeChildren = $(itemContainer).find('iframe');
                    iframeChildren.remove();
                }
                else {
                    var videoChildren = itemContainer.querySelector('video');
                    var playerChildren = itemContainer.querySelector('.ot-video-containingBlock');
                    videoChildren.pause();
                }
            });
        }
    };
    ArticleComboItem.prototype.createIframePlayer = function (url) {
        var externalUrl = 'https://www.youtube.com/embed/';
        externalUrl += url;
        externalUrl += '?rel=0&amp;showinfo=0&enablejsapi=1';
        var createIframe = document.createElement('iframe');
        createIframe.id = 'video__external';
        createIframe.src = externalUrl;
        createIframe.classList.add('video__iframe');
        this.playerContent.appendChild(createIframe);
    };
    ArticleComboItem.prototype.renderTime = function () {
        if (this.playButton.hasAttribute('data-youtube-id')) {
            var videoTimePlaceholder_1 = this.playerTimeContainer;
            var getVideo = this.playButton.getAttribute('data-youtube-id');
            axios.get('https://www.googleapis.com/youtube/v3/videos?part=contentDetails&id=' + getVideo + '&key=AIzaSyBcaoVc-sCwi_7txKMV9BEUhDf4yrcq384', { responseType: 'json' }).then(function (response) {
                var object = response.data.items[0].contentDetails.duration;
                var array = object.match(/(\d+)(?=[MHS])/ig) || [];
                var formatted = array.map(function (item) {
                    if (item.length < 2)
                        return '0' + item;
                    return item;
                }).join(':');
                if (formatted) {
                    videoTimePlaceholder_1.innerHTML = formatted;
                }
                else {
                    videoTimePlaceholder_1.innerHTML = '00:00:00';
                }
            }).catch(function (response) {
                console.log(response);
            });
        }
    };
    ArticleComboItem.prototype.showVideoNoImage = function (element) {
        // this.hideActiveVideoNoImage(element);
        this.playerContainer.classList.add('video-carousel-item__container--playing');
        if (element.hasAttribute('data-youtube-id')) {
            this.isExternal = true;
            var videoExternal = element;
            var getVideo = videoExternal.getAttribute('data-youtube-id');
            this.createIframePlayer(getVideo);
            this.analyticsService.dtmVideoTrackerAutoSpot();
        }
        else {
            if (this.player) {
                if (this.video) {
                    this.player.style.height = "100%";
                    this.video.player.play();
                }
            }
        }
    };
    ArticleComboItem.prototype.hideActiveVideoNoImage = function (element) {
        var selectedVideo = element;
        if (!selectedVideo.classList.contains('video-carousel-item__container--playing')) {
            var videoContainers = Array.from(document.querySelectorAll('.video-carousel-item__container--playing'));
            videoContainers.map(function (itemContainer) {
                itemContainer.classList.remove('video-carousel-item__container--playing');
                var iframeExistence = itemContainer.querySelector('iframe');
                if (iframeExistence) {
                    var iframeChildren = $(itemContainer).find('iframe');
                    iframeChildren.remove();
                }
                else {
                    var videoChildren = itemContainer.querySelector('video');
                    var playerChildren = itemContainer.querySelector('.ot-video-containingBlock');
                    videoChildren.pause();
                }
            });
        }
    };
    return ArticleComboItem;
}(Base));
export { ArticleComboItem };



//////////////////
// WEBPACK FOOTER
// ./components/article-combo-item/article-combo-item.component.ts
// module id = 95
// module chunks = 0